// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.app-navigation-spacer[data-v-b699c557] {
	flex-shrink: 0;
	height: 22px;
}

`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppNavigationSpacer-CfNqmQeR.css"],"names":[],"mappings":";AACA;CACC,cAAc;CACd,YAAY;AACb","sourcesContent":["\n.app-navigation-spacer[data-v-b699c557] {\n\tflex-shrink: 0;\n\theight: 22px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
